import React from 'react'
import PropTypes from 'prop-types'

const ShowcaseLink = ({ productId, x, y, onLinkClick, content, idx, slideId, style }) => {
  let customStyleIndex = productId
  if (slideId) customStyleIndex = `${slideId}_${idx}`
  return (
    <div
      id={`ou_product_link_${productId}`}
      className={`ou_showcase__link ou_showcase_link_${productId} ou_showcase_link_p${customStyleIndex}`}
      // tyle={{...(x > 0) && {left: `${x}rem`}, ...(x < 0) && {right: `${-x}rem`}, transform: `translate(0, ${y}rem)`}}
      style={Object.assign({left: `${x}rem`, transform: `translate(0, ${y}rem)`}, style)}
      onClick={onLinkClick}
    >
      <i className={'ou_showcase__icon'} />
      <span className={'ou_showcase__text'}>{content}</span>
    </div>
  )
}

ShowcaseLink.defaultProps = {
  style: {}
}

ShowcaseLink.propTypes = {
  productId: PropTypes.number,
  x: PropTypes.number,
  y: PropTypes.number,
  onLinkClick: PropTypes.func,
  content: PropTypes.string,
  idx: PropTypes.number.isRequired,
  slideId: PropTypes.string,
  style: PropTypes.object
}

export default ShowcaseLink



// WEBPACK FOOTER //
// ./src/templates/outSide/components/showcase/ShowcaseLink.js